@let $dropdownSize = dropdownSize();
<div
  ngbDropdown
  class="d-inline-flex"
  [container]="dropdownContainer()"
  [display]="dropdownDisplay()"
  [ngClass]="dropdownParentClasses()"
  [placement]="dropdownPlacement()">
  <button
    ngbDropdownToggle
    [attr.aria-disabled]="disabledOrLoading()"
    [attr.id]="id()"
    [class.-no-arrow]="dropdownHideIcon()"
    [disabled]="disabled() || loading()"
    [ngClass]="buttonClasses()"
    [type]="'button'"
    (click)="handleClick($event)">
    <ng-container [ngTemplateOutlet]="buttonContent" />
  </button>
  <ng-template #buttonContent>
    @if (icon()) {
      <span
        [class.mr-0]="square()"
        [class]="iconClasses()"></span>
    }
    <ng-content />
  </ng-template>
  <div
    ngbDropdownMenu
    [attr.aria-labelledby]="id()"
    [class.-arrow]="dropdownShowArrow()"
    [class.-lg]="$dropdownSize === MbsSize.lg"
    [class.-sm]="$dropdownSize === MbsSize.sm">
    <ng-container [ngTemplateOutlet]="dropdownTemplate()" />
  </div>
</div>
